import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { HorizontalNav } from "./components/HorizontalNav";
import { VerticalNav } from "./components/VerticalNav";

export function Components() {
  return (
    <div className="flex flex-column w-100">
      <div className="flex">
        <div className="button mr-4">Contact</div>
        <div className="button flex items-center">
          <div className="mr-2">Next</div>
          <FiArrowRight />
        </div>
      </div>
      <br />
      <HorizontalNav
        setSelectedPhase={() => {
          /*pass*/
        }}
        selectedPhase={0}
      />
      <br />
      <VerticalNav
        selectedPhase={0}
        selectedSubPhase={0}
        setSelectedSubPhase={() => {
          /*pass*/
        }}
      />
    </div>
  );
}
